const getUrlParameter = (name) => {
  name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
  var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
  var results = regex.exec(window.location.search);
  return results === null ? false : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

export default getUrlParameter



// WEBPACK FOOTER //
// ./src/utils/urlParam.js